export type BookedStatus = 'BOOKED';
